import { plainAxiosInstance } from "../axios";

class PlanDetailsService {
  get(contractSku) {
    return plainAxiosInstance.get(`/plan-details/${contractSku}`);
  }
}

export default new PlanDetailsService();
